<template>
  <div
    v-if="state"
    ref="rootRef"
    class="san-virtual-hits"
  >
    <slot v-bind="state">
      <slot
        v-if="nbHits > 0"
        name="list"
        v-bind="virtualItems"
      >
        <component
          :is="listTag"
          class="san-virtual-hits--list"
          :class="[`view--${view}`]"
          :style="{ height: `${totalSizeRows}px` }"
        >
          <component
            :is="itemTag"
            ref="probeRef"
            class="san-virtual-hits--list--probe"
          >
            <slot name="probe" />
          </component>

          <!-- <template
            v-for="item in items"
            :key="item.index"
          > -->
          <!-- <template
            v-for="row in virtualRows"
            :key="row.index"
          > -->
          <!-- {{ console.log(row.index) }} -->
          <component
            :is="itemTag"
            v-for="item in virtualItems"
            :key="item.index"
            v-intersection="onIntersection"
            class="san-virtual-hits--list--item"
            :data-index="item.index"
            :data-page="item.page"
            :style="item.style"
            @click="state.sendEvent('click:internal', item, 'Hit Clicked')"
            @auxclick="state.sendEvent('click:internal', item, 'Hit Clicked')"
          >
            <!-- {{ console.log({ virtualRows, totalSizeRows, totalSizeColumns }) }} -->
            <!-- {{ console.log({ columnCount, row: row.index, column: item.index, key: item.key, item: row.index * columnCount + item.index }) }} -->
            <slot
              v-if="!item.isLoaded"
              name="placeholder"
              v-bind="item"
            >
              placeholder: { index: {{ item.index }}, page: {{ item.page }} }
            </slot>
            <slot
              v-else
              name="item"
              v-bind="item"
            >
              item: { index: {{ item.index }}, page: {{ item.page }} }
            </slot>
          </component>
          <!-- </template> -->
        </component>
      </slot>

      <div
        v-else
        class="no-results"
      >
        <slot name="no-results">
          No results
        </slot>
      </div>
    </slot>
  </div>
</template>

<script setup>
import { ref, toRaw, watch, computed, nextTick, onMounted } from 'vue' // eslint-disable-line
import { scroll } from 'quasar'
import { connectInfiniteHits } from 'instantsearch.js/es/connectors'
import { useConnector } from '@/composables'
import { useVirtualizer } from '@tanstack/vue-virtual' // eslint-disable-line
import { isEqual } from 'lodash'
import { createTaggedQueue } from '@/helpers'

defineOptions({ name: 'SanVirtualHits' })
const props = defineProps({
  showBanner: { type: Boolean, default: true },
  showButtonPrev: { type: Boolean, default: false },
  showButtonNext: { type: Boolean, default: false },
  escapeHTML: { type: Boolean, default: true },
  transformItems: { type: Function, default: undefined },
  cache: { type: Object, default: null },
  listTag: { type: String, default: 'ol' },
  itemTag: { type: String, default: 'li' },
  // itemHeight: { type: Number, required: true, validator: val => Number.isInteger(val) && val >= 1 },
  view: { type: String, default: 'list', validator: val => val === 'list' || val === 'grid' } // list || grid
})

const queue = createTaggedQueue(300)
const { getScrollTarget } = scroll

const cachedHits = ref()
const cachedState = ref()
const items = ref([])
const rootRef = ref()
const probeRef = ref()
const columnCount = ref(0)
const itemSize = ref({ width: 0, height: 0 })

// const noop = () => {}
const getStateWithoutPage = ({ page, ...rest } = {}) => rest
const getInMemoryCache = () => {
  return {
    read: ({ state }) => {
      const hits = isEqual(toRaw(cachedState.value), getStateWithoutPage(state)) ? cachedHits.value : null
      // console.log('%cgetInMemoryCache:read', 'color:orange', hits)
      return hits
    },
    write: ({ state, hits }) => {
      cachedState.value = getStateWithoutPage(state)
      cachedHits.value = hits
      // console.log('%cgetInMemoryCache:write', 'color:cyan', state)
    }
  }
}

const state = useConnector(renderFn => connectInfiniteHits((renderOptions, isFirstRender) => {
  const { instantSearchInstance: { helper, mainHelper: { derivedHelpers } } } = renderOptions // eslint-disable-line
  // for (const derivedHelper of derivedHelpers) {
  //   // console.log('%crefinePage', 'color:magenta', derivedHelper)

  //   derivedHelper.on('search', e => {
  //     console.log('%conSearch', 'color:lime', e)
  //   })
  // }
  // renderOptions.instantSearchInstance.on('render', e => {
  //   console.log('%conRender', 'color:lime', e)
  // })
  // console.log('%crefinePage', 'color:magenta', renderOptions.results?.page, isFirstRender)
  renderFn({
    ...renderOptions,
    refinePage: async page => {
      // if ((page - 1) in cachedHits.value) return
      helper.setPage(page)
      helper.search()
    }
  }, isFirstRender)
}, params => {
  console.log('%cunmount', 'color:orange')
}), {
  $$widgetType: 'ais.infiniteHits',
  showBanner: props.showBanner,
  showPrevious: props.showButtonPrev,
  escapeHTML: props.escapeHTML,
  transformItems: props.transformItems,
  cache: props.cache || getInMemoryCache()
})

const nbHits = computed(() => state.value?.results.nbHits || 0)
const hitsPerPage = computed(() => state.value?.results.hitsPerPage || 0)
// const itemSize = computed(() => { // eslint-disable-line
//   if (!probeRef.value) return { width: 0, height: 0 }
//   return {
//     width: probeRef.value.getBoundingClientRect().width,
//     height: probeRef.value.getBoundingClientRect().height
//   }
// })
// const columnCount = computed(() => { // eslint-disable-line
//   if (!rootRef.value || !itemSize.value) return 1
//   return Math.floor(rootRef.value.getBoundingClientRect().width / itemSize.value.width) || 1
// })

const rowVirtualizerOptions = computed(() => {
  const options = {
    count: nbHits.value > 0 && columnCount.value > 0 ? Math.ceil(nbHits.value / columnCount.value) : 0,
    getScrollElement: () => rootRef.value ? getScrollTarget(rootRef.value) : Window,
    // estimateSize: () => 50,
    estimateSize: () => itemSize.value.height,
    overscan: 5,
    gap: 20
  }
  // console.log('%crowVirtualizerOptions', 'color:crimson', itemSize.value.height, options)

  return options
})
const rowVirtualizer = useVirtualizer(rowVirtualizerOptions)

const columnVirtualizerOptions = computed(() => {
  const options = {
    horizontal: true,
    count: columnCount.value,
    getScrollElement: () => rootRef.value ? getScrollTarget(rootRef.value) : Window,
    // estimateSize: () => 1290,
    estimateSize: () => itemSize.value.width,
    overscan: 0,
    gap: 20
  }
  // console.log('%ccolumnVirtualizerOptions', 'color:orange', itemSize.value.width, options)

  return options
})
const columnVirtualizer = useVirtualizer(columnVirtualizerOptions)

const virtualItems = computed(() => {
  const rows = rowVirtualizer.value.getVirtualItems()
  const cols = columnVirtualizer.value.getVirtualItems()
  // console.log('virtualItems', { rows, cols })
  // console.log('%cvirtualItems', 'color:lime', cachedHits.value, state)
  const items = rows.flatMap(r => {
    return cols.map(c => {
      const index = r.index * cols.length + c.index
      const page = Math.floor(index / hitsPerPage.value) + 1
      const loadedItemIndex = (index + 1) % hitsPerPage.value
      const loadedPageItems = cachedHits.value ? cachedHits.value[page - 1] : 0
      let item = {
        row: r.index,
        column: c.index,
        index,
        page,
        style: {
          gridArea: '1/1',
          width: `${c.size}px`,
          height: `${r.size}px`,
          transform: `translateX(${c.start}px) translateY(${r.start}px)`
        },
        isLoaded: cachedHits.value ? page - 1 in cachedHits.value : false
      }
      if (index === 0 || loadedItemIndex === 0) item.isObserved = true
      if (loadedPageItems) item = { ...item, ...loadedPageItems[loadedItemIndex] }

      return item
    })
  })
  return items
})
const totalSizeRows = computed(() => rowVirtualizer.value.getTotalSize()) // eslint-disable-line
const totalSizeColumns = computed(() => columnVirtualizer.value.getTotalSize()) // eslint-disable-line
const onIntersection = async entry => {
  const page = parseInt(entry.target.dataset.page, 10)
  const nextPageIndex = page

  if (cachedHits.value && entry.isIntersecting && !(nextPageIndex in cachedHits.value)) {
    // await nextTick()
    // console.log(state.value)
    // state.value.showMore()
    // state.value.refinePage(nextPageIndex)
    queue.enqueue(() => {
      state.value.refinePage(nextPageIndex)
      console.log('Running for page', nextPageIndex)
    }, nextPageIndex)
  }
}
watch(() => cachedHits.value, val => {
  // console.log('%ccachedHits', 'color:crimson', val)
  if (nbHits.value < 1) {
    items.value = []
    return
  }

  // for (let index = 0; index < nbHits.value; index++) {
  //   const page = Math.floor(index / hitsPerPage.value) + 1
  //   const loadedItemIndex = (index + 1) % hitsPerPage.value
  //   const loadedPageItems = val[page - 1]
  //   let item = { index, page, isLoaded: page - 1 in val }
  //   if (index === 0 || loadedItemIndex === 0) item.isObserved = true
  //   if (loadedPageItems) item = { ...item, ...loadedPageItems[loadedItemIndex] }
  //   items.value[index] = item
  // }
}, { deep: true })

watch([
  () => props.view,
  () => probeRef.value
], async ([newView, newProbe], [oldView, oldProbe]) => {
  if (!newProbe) return
  await nextTick()
  itemSize.value = {
    width: newProbe.getBoundingClientRect().width,
    height: newProbe.getBoundingClientRect().height
  }
  columnCount.value = Math.floor(rootRef.value.getBoundingClientRect().width / itemSize.value.width) || 1
}, { immediate: true })

</script>
